import { CreateImageRequest, ImageItem } from "@app/types";
import HttpService from "@core/services/http/http.service";

/** Cloud PC (tab Cloud PC của trang Thuê máy tính). Đổi đường truyền, IP xoay, Tunnel, Play Game, Gia hạn, Xoá máy dùng API của máy vật lý. */
class _CloudPcService {
  /** Tạo máy: API trừ tiền, tạo Image (đang khởi tạo) rồi tạo VM ở nền, xong báo qua socket boot_result như máy vật lý */
  public create(request: CreateImageRequest) {
    return HttpService.post<ImageItem>("/cloud-pc", {
      body: { ...request },
    });
  }

  /** Bật máy (khách lỡ shutdown trong Windows / tạo xong máy chưa bật): API gọi start_vm ở nền, luôn báo thành công */
  public start(imageId: string) {
    return HttpService.post<{ statusCode: number; message: string }>(`/cloud-pc/start/${imageId}`);
  }

  /** Reset máy: restart VM */
  public restart(imageId: string) {
    return HttpService.post<{ statusCode: number; message: string }>(`/cloud-pc/restart/${imageId}`);
  }

  public getRDPFile(imageId: string) {
    return HttpService.requestDownload(`/cloud-pc/file/${imageId}`);
  }
}

const CloudPcService = new _CloudPcService();

export default CloudPcService;
